import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { AuthenticationResponseModel } from '../model/authentication-response.model';
import { version } from '../../../../environments/version';

@Component({
  standalone: false,
  selector: 'app-patient-auto-login',
  templateUrl: 'patient-auto-login.component.html',
  styleUrls: ['patient-auto-login.component.scss']
})
export class PatientAutoLoginComponent implements OnInit {
  public outStr = 'Attempting auto login...';
  isLoading: boolean = false;
  token: string;
  logoUrl: string = '';
  appVersion: string = version;
  mounted: boolean = false;
  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly authService: AuthenticationService,
    private readonly cdr: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    this.isLoading = false;
    this.token = this.route.snapshot.paramMap.get('t');
    console.log('PatientAutoLoginComponent ngOnInit entered token:', this.token);

    // Trigger entrance animation after view init
    setTimeout(() => {
      this.mounted = true;
    }, 50);

    this.authService.getLocationLogo().subscribe({
      next: (logoData: any) => {
        this.logoUrl = logoData;
      },
      error: (error) => {
        console.error('error getting location logo: ' + error.message);
        this.logoUrl = '';
      }
    });

    //const formId: string = this.route.snapshot.paramMap.get('formId')!;

    if (this.token) {
      this.isLoading = true;
      this.authService.autoLoginPatient(this.token).subscribe({
        next: (res: AuthenticationResponseModel) => {
          console.log('auto login response:', res);
          if (res.isSuccess) {
            localStorage.setItem('TDOauthToken', res.token);

            // CL-618/CL-621: a "Send Link to Patient Only" magic-link email carries these so the
            // patient lands directly on the specific document's viewer instead of just the
            // generic portal home - see PatientPortalHomeComponent.ngOnInit, which reads them
            // back out on the other side of this navigation.
            const appointmentId = this.route.snapshot.queryParamMap.get('appointmentId');
            const documentId = this.route.snapshot.queryParamMap.get('documentId');

            this.router.navigate(['/patientportal/home'], appointmentId && documentId
              ? { queryParams: { appointmentId, documentId } }
              : undefined);
          }
          else {
            this.isLoading = false;
            this.outStr = 'Token Authentication Failed';
          }
        },
        error: (error) => {
          console.error('auto login error:', error);
          this.isLoading = false;
          this.outStr = 'Token Authentication Failed';
        },
        complete: () => {
          this.cdr.detectChanges();
        }
      });
    }
  }

  requestToken() {
    this.isLoading = true;
    this.outStr = 'Requesting new token...';
    this.authService.requestResendToken(this.token).subscribe({
      next: (res: AuthenticationResponseModel) => {
        console.log('request token response:', res);
        this.isLoading = false;
        if (res) {
          this.outStr = 'New token requested. Please check your email or phone messages for the access link.';
        }
        else {
          this.outStr = 'Token Request Failed';
        }
      },
      error: (error) => {
        console.error('request token error:', error);
        this.outStr = 'Token Request Failed';
        this.isLoading = false;
      },
      complete: () => {
        this.cdr.detectChanges();
      }
    });
    }
}
